module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-decoration-none-523519f3ec66225fb27537631daa469a.png";